module.exports = __webpack_public_path__ + "static/media/police-station.925e16db.svg";